import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 11 12"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.166 5.134a1 1 0 0 1 0 1.732l-8 4.618a1 1 0 0 1-1.5-.866V1.381a1 1 0 0 1 1.5-.866l8 4.619Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }